import { STATUS_STYLES, SERVICE_STYLES, serviceCategory } from "@/lib/constants";

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold ${cls}`}
    >
      {status}
    </span>
  );
}

export function ServiceBadge({ service }) {
  const cat = serviceCategory(service);
  const cls = SERVICE_STYLES[cat];
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {service}
    </span>
  );
}

const PAY_LABEL = {
  "Tagihan Belum Final": ["TAGIHAN BELUM FINAL", "bg-indigo-100 text-indigo-700 border-indigo-200"],
  "Tidak Perlu Bayar": ["TIDAK PERLU BAYAR", "bg-slate-100 text-slate-500 border-slate-200"],
  "Belum Bayar": ["BELUM BAYAR", "bg-rose-50 text-rose-600 border-rose-200"],
  "Menunggu Verifikasi": ["MENUNGGU VERIFIKASI", "bg-amber-100 text-amber-700 border-amber-200"],
  "DP Terbayar": ["DP TERBAYAR", "bg-violet-100 text-violet-700 border-violet-200"],
  "Sebagian Terbayar": ["SEBAGIAN TERBAYAR", "bg-sky-100 text-sky-700 border-sky-200"],
  "Lunas": ["LUNAS", "bg-emerald-100 text-emerald-700 border-emerald-200"],
  "Ditolak": ["DITOLAK", "bg-red-100 text-red-700 border-red-200"],
  "Refund": ["REFUND", "bg-slate-200 text-slate-600 border-slate-300"],
  "Refund Sebagian": ["REFUND SEBAGIAN", "bg-orange-100 text-orange-700 border-orange-300"],
  "Refund Penuh": ["REFUND PENUH", "bg-neutral-200 text-neutral-700 border-neutral-400"],
};

export function PaymentBadge({ status }) {
  if (!status) return null;
  const [label, cls] = PAY_LABEL[status] || [String(status), "bg-slate-100 text-slate-600 border-slate-200"];
  return (
    <span data-testid={`pay-badge-${status}`} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold ${cls}`}>
      {label}
    </span>
  );
}
